import { useMemo } from "react"
import { usersColumns } from "./resouces/table/columns/_columns_3"
import { EventsListWrapper } from "./resouces/ResourcesList"

const  TranslationPage = () => {
  const columns = useMemo(() => usersColumns, []);

  return <EventsListWrapper columns={columns} />
}

export default TranslationPage